import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NewMainWidgetTextField } from 'views/rebranded-module/common/components/UI/NewMainWidget/NewMainWidgetTextField';

  interface StyledGridProps {
  bordered?: boolean;
  error?: boolean;
}
const StyledGrid = styled(Grid)<StyledGridProps>(({ theme, bordered, error }) => ({
  border: (bordered ||error ) ? `1px solid ${theme.palette.border[3]}`: 0,
  borderRadius: bordered &&theme.spacing(0.5),
  borderColor: error && theme.palette.error.main ,
  [theme.breakpoints.down('md')]: {
    border: `1px solid ${theme.palette.border[3]}`,
    borderRadius: theme.spacing(0.5),
    borderColor: error && theme.palette.error.main ,
  },
  '& .WidgetDateField': {
    '& .MuiButtonBase-root': {
      '& .MuiSvgIcon-root': {
        visibility: 'hidden',
      },
    },
  },
}));

export const SelectMainWidgetTextField = styled(NewMainWidgetTextField)(
  ({ theme }) => ({
    '& .MuiSelect-icon': {
      display: 'none',
    },
    '& .MuiFilledInput-input':{
     padding: `${theme.spacing(3.6 , 2, 1.75, 1)} !important`,
    },
  }),
);

export default StyledGrid;